import React, { useEffect, useRef } from "react"
import { Box, Flex, useColorMode } from "@chakra-ui/react"
import { chakraTheme } from "../../theme/chakraTheme"
import { pageContentWidth } from "../../common/commonConstants"
import { Colors } from "../../theme/colors"
import { type ChakraProps } from "@chakra-ui/react"

interface InfinityWrapperProps {
  bg?: string
  height?: string | string[]
  children: React.ReactNode
  inputStyles?: ChakraProps
}
export const InfinityWrapper = ({ bg = Colors.Secondary.banner, height = "346px", children, inputStyles }: InfinityWrapperProps): JSX.Element => {
  const { colorMode } = useColorMode()
  const ref = useRef<HTMLDivElement>(null)
  const [bgColor, setBgColor] = React.useState<string>(bg)

  useEffect(() => {
    setBgColor(colorMode === "light" ? bg : chakraTheme.colors.gray[700])
  }, [bg, colorMode])

  return (
    <Box bg={bgColor} w="100%" pos="relative" py="8px" ref={ref} {...inputStyles}>
      <Flex
        w={["100%", "100%", "100%", pageContentWidth, pageContentWidth, pageContentWidth]}
        height={height}
        align={"center"}
        margin={"auto"}
        justify={["center", "center", "center", "space-between", "space-between", "space-between"]}
      >
        {children}
      </Flex>
    </Box>
  )
}
